/*
* 口数計算
*/

export default class NumberFieldsCount {
  constructor() {
    this.$numberFields = document.querySelectorAll('[data-target="numberFields"]');
    this.$addedNumberFields = document.querySelectorAll('[data-target="addedNumberFields"]');
  }

  attachEvent() {
    // 割当済工数
    const numberFields = Object.values(this.$numberFields);
    // 追加割当口数
    const addedNumberFields = Object.values(this.$addedNumberFields);

    const autoAssignedFlg = document.getElementById('autoAssigned');

    Array.prototype.forEach.call(this.$addedNumberFields, numberField => {
      window.addEventListener('pageshow', () => {
        sumNumbers();
      });
      numberField.addEventListener('change', () => {
        sumNumbers();
      });
      // 自動振り分け後なら再計算
      if (autoAssignedFlg != null) {
        sumNumbers();
      }
    });

    function sumNumbers() {
      const displayNumber = document.getElementById('displayNumber');
      let sum = 0;
      numberFields.forEach(function (numberField, index) {
        sum += Number(numberField.value) +  Number(addedNumberFields[index].value);
      });
      displayNumber.textContent = sum;
    }
  }
}
